import Vue from 'vue';
import PluginsTemplate from '../pluginsTemplate';

import BaseModal from 'components/base-ui/base-modal/index';
const BaseModalConstructor = Vue.extend(BaseModal);

class BaseModalPlugin extends PluginsTemplate {
  constructor() {
    super();
    this.defaults = {
      delay: 2000,
    };
  }
  show(options) {
    this.initPros(options);
    // 如果不存在实例 则初始化实例
    if (!this.instance) {
      let newInstance = new BaseModalConstructor({
        el: document.createElement('div'),
      });
      this.initInstance(newInstance);
    }
    // 初始化节点
    this.initDom();
  }
  close() {
    if (!this.instance) {
      return !1;
    }
    this.removeInstance();
  }
}
let instance = new BaseModalPlugin();

export default {
  show(options) {
    instance.show(options);
    return instance;
  },
  close() {
    instance.close();
  },
  install() {
    instance.install();
  },
};
